import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成
import { setStation } from "../../../api/user";
var path = process.env.VUE_APP_BASE_API;
import { getUserList, setUserAuthority, register, deleteUser as _deleteUser } from '@/api/user';
import { getStationBaseInfoList, getStationGroupList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { getAuthorityList } from '@/api/authority';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';
import CustomPic from '@/components/customPic';
import ChooseImg from '@/components/chooseImg';
export default {
  name: 'AdminUser',
  components: {
    CustomPic: CustomPic,
    ChooseImg: ChooseImg
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getUserList,
      path: path,
      authOptions: [],
      stationOptions: [],
      stationGroupOptions: [],
      addUserDialog: false,
      userInfo: {
        username: '',
        password: '',
        nickName: '',
        headerImg: '',
        authorityId: '',
        sellerId: 0,
        stationGroupNo: 0
      },
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }, {
          min: 5,
          message: '最低5位字符',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入用户密码',
          trigger: 'blur'
        }, {
          min: 6,
          message: '最低6位字符',
          trigger: 'blur'
        }],
        nickName: [{
          required: true,
          message: '请输入用户昵称',
          trigger: 'blur'
        }],
        authorityId: [{
          required: true,
          message: '请选择用户角色',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['token'])),
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res, stationOptions, stationGroupOptions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('adminUser created');

              _this.getTableData();

              _context.next = 4;
              return getAuthorityList({
                page: 1,
                pageSize: 999
              });

            case 4:
              res = _context.sent;

              _this.setOptions(res.data.list);

              _context.next = 8;
              return getStationBaseInfoList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 8:
              stationOptions = _context.sent;
              _this.stationOptions = stationOptions.data.list;
              _context.next = 12;
              return getStationGroupList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 12:
              stationGroupOptions = _context.sent;
              _this.stationGroupOptions = stationGroupOptions.data.list;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    openHeaderChange: function openHeaderChange() {
      this.$refs.chooseImg.open();
    },
    setOptions: function setOptions(authData) {
      this.authOptions = [];
      this.setAuthorityOptions(authData, this.authOptions);
    },
    setAuthorityOptions: function setAuthorityOptions(AuthorityData, optionsData) {
      var _this2 = this;

      AuthorityData && AuthorityData.map(function (item) {
        if (item.children && item.children.length) {
          var option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName,
            children: []
          };

          _this2.setAuthorityOptions(item.children, option.children);

          optionsData.push(option);
        } else {
          var _option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName
          };
          optionsData.push(_option);
        }
      });
    },
    deleteUser: function deleteUser(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _deleteUser({
                  id: row.ID
                });

              case 2:
                res = _context2.sent;

                if (res.code === 0) {
                  _this3.getTableData();

                  row.visible = false;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    enterAddUserDialog: function enterAddUserDialog() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$refs.userForm.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
                    var res;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!valid) {
                              _context3.next = 8;
                              break;
                            }

                            _context3.next = 3;
                            return register(_this4.userInfo);

                          case 3:
                            res = _context3.sent;

                            if (res.code === 0) {
                              _this4.$message({
                                type: 'success',
                                message: '创建成功'
                              });
                            }

                            _context3.next = 7;
                            return _this4.getTableData();

                          case 7:
                            _this4.closeAddUserDialog();

                          case 8:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    closeAddUserDialog: function closeAddUserDialog() {
      this.$refs.userForm.resetFields();
      this.addUserDialog = false;
    },
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      this.userInfo.headerImg = res.data.file.url;
    },
    addUser: function addUser() {
      this.addUserDialog = true;
    },
    changeAuthority: function changeAuthority(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return setUserAuthority({
                  uuid: row.uuid,
                  authorityId: row.authority.authorityId
                });

              case 2:
                res = _context5.sent;

                if (res.code === 0) {
                  _this5.$message({
                    type: 'success',
                    message: '角色设置成功'
                  });
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    changeStation: function changeStation(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return setStation({
                  uuid: row.uuid,
                  sellerId: row.sellerId,
                  stationGroupNo: row.stationGroupNo
                });

              case 2:
                res = _context6.sent;

                if (res.code === 0) {
                  _this6.$message({
                    type: 'success',
                    message: '设置成功'
                  });
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};